import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

const MarqueeLabel = () => {
  const baseURL = useSelector((state) => state?.config?.baseURL);
  const [labelData, setLabelData] = useState([]);
  const config = {
    headers: {
      key: "KwachaRides-api-secret-key",
    },
  };
  useEffect(() => {
    axios
      .get(`${baseURL}/category/getCategories`, config)
      .then((response) => {
        setLabelData(response?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching about us data:", error);
      });
  }, []);
  return (
    <div className="containermarquee container-fluid">
      <div className="marquee">
        {labelData?.map((data, index) => (
          <div className="marquee-items" key={index}>
            <p> {data?.categoryName} </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarqueeLabel;
